import React from "react";
import clsx from "clsx";

import {
  ReferenceIssues,
  ReferenceOnePagePortfolioAssessmentIssue,
} from "../../../../state";

import styles from "./Reference.module.scss";

export type ReferenceProps = {
  title: string;
  referenceData: (ReferenceIssues | ReferenceOnePagePortfolioAssessmentIssue)[];
};

const Reference: React.FC<ReferenceProps> = ({ title, referenceData }) => {
  return (
    <div className={styles.reference}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.list}>
        {referenceData.map(reference => {
          if ("issues" in reference) {
            return (
              <li key={reference.id} className={styles.item}>
                <p className={styles.subject}>
                  {reference.name} {reference.title}
                  {reference.issues.map(issue => (
                    <span
                      key={issue.lesson_keyword_id}
                      className={styles.keyword}
                    >
                      keyword {issue.lesson_keyword_name}
                    </span>
                  ))}
                </p>
                <ul className={styles.answerList}>
                  {reference.issues.map(issue =>
                    issue.questions.map(question => {
                      const hasAnswers =
                        !!question.answers && question.answers.length > 0;

                      return (
                        <li
                          key={question.id}
                          className={clsx(
                            styles.answerItem,
                            !hasAnswers && styles.placeholder,
                          )}
                        >
                          {hasAnswers
                            ? question.answers.map(answer => answer.contents)
                            : "振り返りワークの回答が入ります。"}
                        </li>
                      );
                    }),
                  )}
                </ul>
              </li>
            );
          } else {
            return reference.questions.map(question => (
              <li key={question.id} className={styles.item}>
                <p className={styles.subject}>{question.title}</p>
                <ul className={styles.answerList}>
                  <li
                    key={question.id}
                    className={clsx(
                      styles.answerItem,
                      !question.answers?.contents && styles.placeholder,
                    )}
                  >
                    {question.answers?.contents ||
                      "Before WORK の回答が入ります。"}
                  </li>
                </ul>
              </li>
            ));
          }
        })}
      </ul>
    </div>
  );
};

export default Reference;
